"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typedKeys = exports.isUndefined = void 0;
function isUndefined(x) {
    return typeof x === "undefined";
}
exports.isUndefined = isUndefined;
function typedKeys(o) {
    return Object.keys(o);
}
exports.typedKeys = typedKeys;
//# sourceMappingURL=utils.js.map